import { Component, computed, input, model, output } from '@angular/core';
import { FormCheckboxControl } from '@angular/forms/signals';

@Component({
	selector: 'ui-checkbox',
	templateUrl: './checkbox.component.html',
	styleUrls: ['./checkbox.component.scss'],
})
export class CheckboxComponent implements FormCheckboxControl {
	label = input<string>('');
	icon = input<'checkmark' | 'minus'>('checkmark');
	tabindex = input<number>(0);
	disabled = input<boolean>(false);
	invalid = input<boolean>(false);

	checked = model<boolean>(false);

	touch = output<void>();

	labelClasses = computed(() => {
		let returnString = this.getBaseLabelStyles();

		if (this.disabled()) {
			returnString += ' text-secondary-400!';
		}

		return returnString;
	});

	checkboxClasses = computed(() => {
		const isChecked = this.checked();
		const isDisabled = this.disabled();

		let returnString = this.getBaseCheckboxStyles();

		if (isDisabled) {
			returnString += ' cursor-not-allowed! border-secondary-400!';
		}

		if (isChecked) {
			returnString +=
				' before:absolute before:left-1/2 before:top-1/2 before:h-full before:w-full before:transform before:-translate-x-1/2 before:-translate-y-1/2 before:bg-center before:bg-no-repeat before:bg-size-[75%]';

			if (isDisabled) {
				returnString += ' bg-secondary-400! border-secondary-400!';
				returnString += ' before:invert before:brightness-0 before:opacity-100';
			} else {
				returnString += ' bg-secondary-800! border-secondary-800!';
				returnString +=
					' before:invert before:brightness-0 before:brightness-0 dark:before:brightness-100 dark:before:invert-0 before:invert';
			}
		}

		returnString += ` ui-checkbox--${this.icon()}`;

		return returnString;
	});

	toggleCheckbox() {
		if (!this.disabled()) {
			this.checked.set(!this.checked());
			this.touch.emit();
		}
	}

	onKeyDown(event: KeyboardEvent) {
		if (event.key === 'Enter' || event.key === ' ') {
			event.preventDefault();
			this.toggleCheckbox();
		}
	}

	private getBaseLabelStyles(): string {
		return 'flex items-center text-secondary-800 ml-6 mt-[0.06rem] user-select-none';
	}

	private getBaseCheckboxStyles(): string {
		return 'bg-white rounded h-4.5 absolute left-0 w-4.5 top-1/2 -translate-y-1/2 border border-secondary-800 dark:border-secondary-300 peer-focus-visible:ring-2 peer-focus-visible:ring-offset-2 peer-focus-visible:ring-focus';
	}
}
